export const SAVE_IMPORT_EXPORT_WIZARD = 'SAVE_IMPORT_EXPORT_WIZARD';
export type SAVE_IMPORT_EXPORT_WIZARD = typeof SAVE_IMPORT_EXPORT_WIZARD;

export interface SaveImportExportWizard {
    type: SAVE_IMPORT_EXPORT_WIZARD;
}

export function saveImportExportWizardAction(): SaveImportExportWizard {
    return {
        type: SAVE_IMPORT_EXPORT_WIZARD
    };
}
